import React from "react";
import { SITE } from "../config/siteConfig";
import { Logo } from "./Logo";

export function Footer({ phones }) {
  const c = SITE.company;
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="wrap">
        <div className="footer-top">
          <Logo />
          <div className="footer-contact">
            <a href={phones.main.href} className="footer-phone">
              <span>{phones.main.display}</span>
            </a>
            <p>Asesores disponibles {SITE.hours}.</p>
            <p>
              <a href={"mailto:" + c.email}>{c.email}</a>
            </p>
          </div>
        </div>
        <nav className="footer-links" aria-label="Enlaces de interés">
          <a href="/sobre-nosotros">Quiénes somos</a>
          <a href="/contacto">Contacto</a>
          <a href="/preguntas-frecuentes">Preguntas frecuentes</a>
          <a href="/aviso">Aviso importante</a>
          <a href="/aviso-legal">Aviso legal y condiciones de uso</a>
          <a href="/politica-de-privacidad">Política de privacidad</a>
          <a href="/cookies">Política de cookies</a>
        </nav>
        <p className="footer-legal">
          {SITE.siteLabel} es un servicio de comparación editado por {c.name}, CIF {c.cif}, {c.address}.
        </p>
        <p className="footer-disclaimer">
          La información de este sitio es orientativa. {SITE.brandName} no es {SITE.vertical.notA} y no está afiliado
          a ninguna de las marcas citadas, que pertenecen a sus respectivos titulares.
        </p>
        <p className="footer-copy">
          © {year} {c.name}
        </p>
      </div>
    </footer>
  );
}
